import { useToast } from '@fukuri-admins/ui/common/Toast/hooks';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useConfiguration } from '~/contexts/ConfigurationProvider';
import { getClientAdminUser } from '../../../api/client_admin_users/id';
import { ClientAdminUserType } from '../../../types/resources/ClientAdminUserType';
import { IntegratedClientAdminUser } from './IntegratedClientAdminUser';
import { StandardClientAdminUser } from './StandardClientAdminUser';

export const ShowClientAdminUser = () => {
  const { client_admin_id } = useParams();
  const { applicationConfiguration } = useConfiguration();
  const [clientAdminUser, setClientAdminUser] = useState<ClientAdminUserType>();
  const { showToast } = useToast();
  const init = async () => {
    if (!client_admin_id) return;
    try {
      const data = await getClientAdminUser(client_admin_id);
      const clientAdminUserData = data.client_admin_user;
      setClientAdminUser(clientAdminUserData);
    } catch {
      showToast({ message: 'データの取得に失敗しました。', status: 'danger' });
    }
  };

  useEffect(() => {
    init();
  }, []);

  return (
    <div>
      {applicationConfiguration.application_configuration.is_api_integration ? (
        <IntegratedClientAdminUser clientAdminUser={clientAdminUser} />
      ) : (
        <StandardClientAdminUser clientAdminUser={clientAdminUser} />
      )}
    </div>
  );
};
